// extracted by mini-css-extract-plugin
export var link = "subheaderListLinks-module--link---UHbP";
export var linkItem = "subheaderListLinks-module--linkItem--ZxEYh";
export var linkItemContainer = "subheaderListLinks-module--linkItemContainer--y0rnH";
export var linksContainer = "subheaderListLinks-module--linksContainer--AgCmY";
export var oneColumn = "subheaderListLinks-module--oneColumn--h1j1P";
export var sbShowMain = "subheaderListLinks-module--sb-show-main--IVEri";
export var subheaderListLinks = "subheaderListLinks-module--subheaderListLinks--bB48V";
export var title = "subheaderListLinks-module--title--hT5GI";
export var twoColumns = "subheaderListLinks-module--twoColumns--ksely";